export default "__VITE_ASSET__d4626d98__"